var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_63425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 17,
    height: 5
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16.5,
    width: 16.5,
    height: 4.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_63425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00146 17.501C7.00146 17.2358 6.89611 16.9814 6.70857 16.7939C6.52104 16.6063 6.26668 16.501 6.00146 16.501C5.73625 16.501 5.48189 16.6063 5.29436 16.7939C5.10682 16.9814 5.00146 17.2358 5.00146 17.501V19.501C5.00146 19.7662 5.10682 20.0205 5.29436 20.2081C5.48189 20.3956 5.73625 20.501 6.00146 20.501H20.0015C20.2667 20.501 20.521 20.3956 20.7086 20.2081C20.8961 20.0205 21.0015 19.7662 21.0015 19.501V17.501C21.0015 17.2358 20.8961 16.9814 20.7086 16.7939C20.521 16.6063 20.2667 16.501 20.0015 16.501C19.7362 16.501 19.4819 16.6063 19.2944 16.7939C19.1068 16.9814 19.0015 17.2358 19.0015 17.501V18.501H7.00146V17.501ZM12.4215 3.68098L8.42147 6.50098C8.20588 6.65391 8.05961 6.88598 8.01463 7.14645C7.96966 7.40692 8.02964 7.6746 8.18146 7.89097C8.25725 7.99913 8.35371 8.0912 8.46527 8.16187C8.57683 8.23254 8.70129 8.28042 8.83145 8.30273C8.96161 8.32505 9.09491 8.32136 9.22364 8.29188C9.35237 8.2624 9.47398 8.20771 9.58146 8.13097L12.0015 6.41098V14.501C12.0015 14.7662 12.1068 15.0205 12.2944 15.2081C12.4819 15.3956 12.7362 15.501 13.0015 15.501C13.2667 15.501 13.521 15.3956 13.7086 15.2081C13.8961 15.0205 14.0015 14.7662 14.0015 14.501V6.50098L16.4015 8.30098C16.5065 8.37977 16.6261 8.4371 16.7533 8.46969C16.8805 8.50228 17.0129 8.5095 17.1429 8.49093C17.2729 8.47235 17.398 8.42836 17.511 8.36145C17.624 8.29454 17.7227 8.20603 17.8015 8.10098C17.9313 7.92788 18.0015 7.71735 18.0015 7.50098C18.0015 7.34573 17.9653 7.19262 17.8959 7.05376C17.8265 6.91491 17.7257 6.79412 17.6015 6.70098L13.6015 3.70098C13.4323 3.5729 13.2269 3.50194 13.0147 3.49835C12.8026 3.49475 12.5948 3.55871 12.4215 3.68098Z",
    fill: "#0C0589"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_281_63425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 3,
    width: 11,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 10.5,
    height: 13.5,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_281_63425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0015 1.5C19.0015 1.76522 19.1068 2.01957 19.2944 2.20711C19.4819 2.39464 19.7362 2.5 20.0015 2.5C20.2667 2.5 20.521 2.39464 20.7086 2.20711C20.8961 2.01957 21.0015 1.76522 21.0015 1.5V-0.5C21.0015 -0.765216 20.8961 -1.01957 20.7086 -1.20711C20.521 -1.39464 20.2667 -1.5 20.0015 -1.5L6.00146 -1.5C5.73625 -1.5 5.48189 -1.39464 5.29436 -1.20711C5.10682 -1.01957 5.00146 -0.765216 5.00146 -0.5V1.5C5.00146 1.76522 5.10682 2.01957 5.29436 2.20711C5.48189 2.39464 5.73625 2.5 6.00146 2.5C6.26668 2.5 6.52104 2.39464 6.70857 2.20711C6.89611 2.01957 7.00146 1.76522 7.00146 1.5V0.5L19.0015 0.5V1.5ZM13.5815 15.32L17.5815 12.5C17.7971 12.3471 17.9433 12.115 17.9883 11.8545C18.0333 11.5941 17.9733 11.3264 17.8215 11.11C17.7457 11.0018 17.6492 10.9098 17.5377 10.8391C17.4261 10.7684 17.3016 10.7206 17.1715 10.6982C17.0413 10.6759 16.908 10.6796 16.7793 10.7091C16.6506 10.7386 16.5289 10.7933 16.4215 10.87L14.0015 12.59V4.5C14.0015 4.23478 13.8961 3.98043 13.7086 3.79289C13.521 3.60536 13.2667 3.5 13.0015 3.5C12.7362 3.5 12.4819 3.60536 12.2944 3.79289C12.1068 3.98043 12.0015 4.23478 12.0015 4.5V12.5L9.60147 10.7C9.49641 10.6212 9.37686 10.5639 9.24965 10.5313C9.12243 10.4987 8.99004 10.4915 8.86004 10.5101C8.73004 10.5286 8.60497 10.5726 8.49197 10.6395C8.37897 10.7064 8.28026 10.7949 8.20147 10.9C8.07164 11.0731 8.00146 11.2836 8.00146 11.5C8.00146 11.6552 8.03761 11.8084 8.10704 11.9472C8.17647 12.0861 8.27727 12.2069 8.40146 12.3L12.4015 15.3C12.5706 15.4281 12.7761 15.499 12.9882 15.5026C13.2003 15.5062 13.4081 15.4423 13.5815 15.32Z",
    fill: "#0C0589"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.980134919cd25c5cf876a758aa79445b.svg";
export { ForwardRef as ReactComponent };